import { NMEADisplay } from '@jbroll/nmea-widgets';

export function App() {
    return (
        <div className="min-h-screen bg-gray-50">
            <NMEADisplay />
        </div>
    );
}
